<template>
  <aside class="aside-menu">

  </aside>
</template>

<script>
export default {
  name: 'aside'
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue?6330240f